/**
 * Formatea un monto con miles por puntos y decimales por comas,
 * devolviendo la cadena con el código de moneda al inicio.
 *
 * Ejemplos:
 *  formatCurrency(6552, 'USD') => "USD 6.552,00"
 *  formatCurrency(274.43, 'USD') => "USD 274,43"
 *  formatCurrency(25330032, 'COP') => "COP 25.330.032,00"
 *  formatCurrency(19419691.2, 'COP') => "COP 19.419.691,20"
 *  formatCurrency(844334.4, 'COP') => "COP 844.334,40"
 */
function normalizeToNumber(value) {
    if (value === null || value === undefined) return NaN;
    if (typeof value === 'number') return value;

    // Limpia cualquier carácter que no sea dígito, punto o signo
    const cleaned = String(value).replace(/[^\d.-]/g, '');
    const num = Number(cleaned);
    return Number.isFinite(num) ? num : NaN;
}

/**
 * @param {number|string} value - Monto a formatear.
 * @param {string} currency - Código de moneda (ej: "USD", "COP").
 * @param {{ useGrouping?: boolean }} options - Opcional: agrupar miles.
 * @returns {string} Ej: "USD 25.330.032,00"
 */
export default function formatCurrency(value, currency = 'USD', options = {}) {
    const { useGrouping = true } = options;

    const num = normalizeToNumber(value);
    if (!Number.isFinite(num)) return `${currency} 0,00`;

    const isNegative = num < 0;
    const abs = Math.abs(num);

    const formatted = new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping,
    }).format(abs);

    // "USD -1.234,00" para negativos
    return `${currency} ${isNegative ? '-' : ''}${formatted}`;
}
